import { IReportsObject } from "../../interfaces/IReportsObject";
import { setREPORTSOBJECT } from "../constants/reportsObject.types";

export const setReportsObject = (reportsObject: IReportsObject) => {
  return {
    type: setREPORTSOBJECT,
    payload: reportsObject,
  };
};
